export const VISIBILITY_TEST_QUERY_PARAM = 'test';

/**
 * Explicit test-mode flag from a query value.
 * `true` / `false` (case-insensitive) → on / off.
 * Missing or any other value → `null` (keep the current SPA state).
 */
export function parseVisibilityTestQueryParam(raw: unknown): boolean | null {
  const value = Array.isArray(raw) ? raw[0] : raw;
  if (value == null || value === '') {
    return null;
  }
  const normalized = String(value).trim().toLowerCase();
  if (normalized === 'true') {
    return true;
  }
  if (normalized === 'false') {
    return false;
  }
  return null;
}

export function resolveVisibilityTestMode(queryValue: unknown, currentlyEnabled: boolean): boolean {
  const parsed = parseVisibilityTestQueryParam(queryValue);
  return parsed === null ? currentlyEnabled : parsed;
}

export function readVisibilityTestQueryFromUrl(url: string): string | null {
  const queryIndex = url.indexOf('?');
  if (queryIndex === -1) {
    return null;
  }
  const hashIndex = url.indexOf('#', queryIndex);
  const query = url.slice(queryIndex + 1, hashIndex === -1 ? undefined : hashIndex);
  return new URLSearchParams(query).get(VISIBILITY_TEST_QUERY_PARAM);
}
